"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntitySaleContract = exports.isSaleContractV2 = exports.PricingClauseList = exports.ShipmentSizeUnitList = exports.ImportPermitRecipientList = exports.ImportPermitDueDateBeforeList = exports.RestrictionTypeList = void 0;
const common_contracts_types_1 = require("@myfrey/common-contracts-types");
__exportStar(require("@myfrey/common-contracts-types"), exports);
exports.RestrictionTypeList = ["Preferred", "Prohibited", "Required", "Unpreferred"];
exports.ImportPermitDueDateBeforeList = [
    "Prior to the commencement of the shipment period",
    "Prior to vessel ETD",
];
exports.ImportPermitRecipientList = ["Frey", "Broker"];
exports.ShipmentSizeUnitList = common_contracts_types_1.WeightUnitsListWithoutPounds.filter((value) => value != "Bushel" && value != "Pound");
exports.PricingClauseList = [
    "Futures pricing to be completed by the First Notice Day and the first day of the shipment period",
    "Futures pricing to be completed 5 days prior to 1st booking ETA at Destination",
    "Price to be fixed latest on B/L date for first shipment",
    "Futures pricing to be completed at the latest one working day before the First Notice Day or 5 days prior to commencement of shipping period, whichever is earlier",
    "Futures pricing to be completed at the latest one working day before the First Notice Day or 7 days prior to commencement of shipping period, whichever is earlier",
    "Futures pricing to be completed latest 3 working days after BL date",
    "Futures pricing to be completed at the latest one working day before the First Notice Day or before commencement of shipping period, whichever is earlier",
    "Futures pricing to be completed latest 5 working days after BL date",
    "Futures pricing to be completed 3 days prior to 1st booking ETA at Destination",
    "Futures pricing to be completed at the latest one working day before the First Notice Day or 3 days prior to commencement of shipping period, whichever is earlier",
    "Futures pricing to be completed at the latest one working day before the First Notice Day, latest 20 days after first shipment date from WC or latest 5 days before ETA, whichever is earlier",
    "Futures pricing to be completed at the latest 10 days before the ETA of the first booking",
    "Futures pricing to be completed latest 15 working days after BL date",
];
function isSaleContractV2(contract) {
    return typeof contract.id === "string";
}
exports.isSaleContractV2 = isSaleContractV2;
const testKeys = [
    { key: "id", type: "string" },
    { key: "type", value: "Sale" },
    { key: "buyer", type: "object" },
    { key: "seller", type: "object" },
    { key: "freeTime", type: "object" },
];
function isEntitySaleContract(entity) {
    if (typeof entity !== "object" || Array.isArray(entity) || entity === null)
        return false;
    const typedEntity = entity;
    return testKeys.every(({ key, type, value }) => value ? typedEntity[key] === value : typeof typedEntity[key] === type);
}
exports.isEntitySaleContract = isEntitySaleContract;
